<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>La llegada de los primeros franciscanos 1524</h2>
    <img @click="imageClicked(0)" src="galerias/tenochtitlan/g8/g8.jpg" class="mainphoto"/>
    <p class='photo-description'>Los 12 primeros franciscanos. Pintura mural, Segunda mitad siglo XVI. Museo de la Evangelización "Ex Convento de Huejotzingo"</p>
    <p>Una de las tareas más importantes de la Corona Española, después de la caída de Tenochtitlan, fue la evangelización. Los primeros en difundir el cristianismo entre los pueblos conquistados fueron doce franciscanos, quienes llegaron al puerto de San Juan de Ulúa, en Veracruz, el 13 de mayo de 1524, dirigidos por Fray Martín de Valencia: Francisco de Soto, Martín de la Coruña, Juan Juárez, Antonio de Ciudad Rodrigo, Toribio de Benavente, García de Cisneros, Luis de Fuensalida, Juan de Ribas, Francisco Jiménez, Andrés de Córdoba y Juan de Palos.</p>
    <!-- <p>VER MÁS</p> -->
    <p>Casi un mes después, el 17 o 18 de junio entraban a la Ciudad de México.</p>
    <p>Las dos áreas geográficas para iniciar el proceso de evangelización fueron la Ciudad de México y la región de las actuales Puebla y Tlaxcala. En estas regiones se instalaron los primeros conventos aprovechando la existencia de importantes ciudades indígenas, por el número de habitantes y por su influencia política. Así, los primeros conventos que fundaron fueron los de Tlaxcala y Ciudad de México. Continuó Huejotzingo que permitió la expansión hacia Cholula, Tepeaca, Tecamachalco, Tehuacán, Chietla y la zona mixteca.</p>
    <h4>Fray Pedro de Gante y San José de los Naturales</h4>
    <img @click="imageClicked(1)" src="galerias/tenochtitlan/g8/G8_a.png" class="mainphoto"/>
    <p class='photo-description'>Códice Osuna. Varios autores, Papel europeo, 1565. Col. Biblioteca Nacional de España.</p>
    <p>Entre los primeros misioneros que llegaron, en agosto de 1523,  estuvo Pedro de Gante, quien se destacó por su dedicación educativa, logrando la fundación de dos colegios, primeros modelos educativos en América: el colegio de Texcoco en 1523 y el de San José de los Naturales. Lo que permitió construir puentes culturales entre dos mundos que comenzaban a dialogar a través del conocimiento y no con las armas.</p>
    <h4>El Colegio de la Santa Cruz de Santiago Tlatelolco</h4>
    <img @click="imageClicked(2)" src="galerias/tenochtitlan/g8/G8_b.png" class="mainphoto"/>
    <p class='photo-description'>Códice de la Cruz-Badiano. Martín de la Cruz y Juan Badiano. Papel europeo, 1552. Col. Biblioteca Nacional de Antropología e Historia</p>
    <p>A partir del esfuerzo de fray Pedro de Gante se buscó la creación de un colegio que enseñara a la nobleza indígena conocimientos que ayudaran a la evangelización y al desarrollo educativo, creándose el Colegio de la Santa Cruz en Tlatelolco, abierto el 6 de enero de 1536, fue la primera institución educativa de alta formación en América que enseñara, de manera obligatoria, latín, gramática, retórica, lógica, geometría, aritmética, astronomía, música, medicina y el estudio de autores clásicos europeos.</p>
    <h5>VER MÁS</h5>
    <ul>
      <li><a target="_blank" href='https://codicecruz-badiano.com'>codicecruz-badiano.com</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Sala1m8",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
